<template>
  <div id="container" class="img-placeholder">
    <WebGLTip v-if="!supportWebGL" />
    <template v-else-if="baseInfoLoaded">
      <section class="wrapper js-vr-exhibition overall-wrapper" id="wrap">
        <!-- start 新交互页面操作按钮块v1版本 -->
        <div id="funcareaShow_v1" v-if="functionDataLoaded">
          <Loading />
          <Hall3dLayer />
          <ActivityArea :isSHowSmartGuide="isSHowSmartGuide" />
          <VROncall v-if="isIcsCallingShow" />
          <AppHeader :isSHowSmartGuide="isSHowSmartGuide" />
          <!--老版本带有VR带看的底部-->
          <!-- <Bottom /> -->
          <!--老版本带有VR带看的底部-->
          <!--24年带有导览的底部-->
          <BottomNew ref="bottomNewRef" :audioContent="audioContent" :hasSmartGuide="hasSmartGuide" :muted="muted"/>
          <!--24年带有导览的底部-->
        </div>
        <!-- end 新交互页面操作按钮块v1版本 -->
        <VrContainer />
      </section>
      <!--短信验证码 start-->
      <ImgValidCodeSMSNew />
      <!--短信验证码 end-->
      <!--智能召回弹层-->
      <ReCalledCustomer />
      <Popup />
      <DlrQuotationEntry
        v-if="showDlrQuotation"
        :isIcs="isICSApp"
        :seriesId="seriesId"
      ></DlrQuotationEntry>
      <DlrQuotationLoad v-if="showDlrQuotationLoad"></DlrQuotationLoad>
      <vr-bottom-menu :dealer-id="dealerId" v-if="functionDataLoaded" />
      <saler-fixed-tips v-if="isIcsCallingShow" />
      <LeftFloor :isSHowSmartGuide="isSHowSmartGuide"></LeftFloor>
      <MultipleFloors :isSHowSmartGuide="isSHowSmartGuide"></MultipleFloors>
    </template>
  </div>
</template>

<script>
/** 组件 */
import AppHeader from '@/components/Header';
import ActivityArea from '@/components/ActivityArea';
import Hall3dLayer from '@/components/FrameLayers/Hall3dLayer.vue';
import Loading from '@/components/Loading.vue';
import WebGLTip from '@/components/WebGLTip';
import Popup from '../components/Popup/Index';
import ImgValidCodeSMSNew from '@/components/Order/ImgValidCodeSMSNew';
import VROncall from '../components/VR/VROnCall.vue';
import DlrQuotationEntry from '../components/PriceList/dlrQuotationEntry.vue';
import DlrQuotationLoad from '../components/PriceList/dlrQuotationLoad.vue';
import BottomNew from '../components/BottomNew/Bottom.vue';
/** 服务 */
import { mapGetters, mapActions, mapMutations } from 'vuex';
import config from '@/config/index';
import util from '@/utils/util';
import pvTrack from '@/services/pvtrack.service';
import homePoup from '../services/homePoup';
import { initResizeEvent } from '@/common';
import { isWorkTime } from '@/services/vrShow/vr.show.loader';
import { Logger } from '../services/logger';
import * as queryValue from '../services/query.const';
import { ShareManager, shareManager } from '../services/share.manager';
import sharedRedbag from '../services/share/sharedRedPacket';
import {
  staticIdProxy,
  actionProxy,
} from '../services/socketIO/user.action.interceptor';
import { hideLoading } from '../services/loading.service';
import { userSeriesCarLayer } from '../services/selectSeriesCar.service';
import utils from '../utils/util';
import LeftFloor from '../components/LeftFloor.vue';
import MultipleFloors from '../components/MultipleFloors.vue';
import SmartGuide from '@/services/smartGuide.service';
import smartApi from '@/apis/smart.api';
import { CarTaskExecutor } from '@/services/audio.service';
import eventBus from '@/services/eventBus.service';
const isInWorkTime = isWorkTime();
const isICSApp = util.isICSApp();
let smartGide = null;
let preMuted = false
export default {
  name: 'Hall',
  components: {
    BottomNew,
    AppHeader,
    ActivityArea,
    Hall3dLayer,
    Loading,
    VrBottomMenu: () => {
      if (isICSApp) {
        return import(
          /* webpackChunkName: "VRBottomMenu" */ '@/components/VR/VRSalerPop/VRBottomMenu.vue'
        );
      }
      return null;
    },
    SalerFixedTips: () => {
      if (isICSApp) {
        return import(
          /* webpackChunkName: "SalerFixedTips" */ '@/components/VR/VRSalerPop/SalerFixedTips.vue'
        );
      }
      return null;
    },
    VROncall,
    ReCalledCustomer: () => {
      if (util.browser.isApp) {
        return import(
          /* webpackChunkName: "ReCalledCustomer" */ '@/components/ReCalledCustomer'
        );
      }
      return null;
    },
    WebGLTip,
    ImgValidCodeSMSNew,
    VrContainer: () => {
      return import(
        /* webpackChunkName: "VrContainer" */ '@/components/VrContainer'
      );
    },
    Popup,
    LeftFloor,
    DlrQuotationEntry,
    MultipleFloors,
    DlrQuotationLoad,
  },
  inject: ['panoPromise'],
  provide:function() {
    return {
      taskExecutor:()=>this.taskExecutor
    };
  },
  data() {
    return {
      baseInfoLoaded: false,
      functionDataLoaded: false,
      imEnv: config.imEnv,
      adviser: null,
      unReadCount: 0,
      realtimeanswer: this.$queryParams.realtimeanswer,
      isICSApp,
      supportWebGL: utils.supportWebGL && !utils.browser.isIE,
      delay: false,
      audioContent: null,
      taskExecutor: null,
      hasSmartGuide: false,
      muted: false,
      sceneId:''
    };
  },
  computed: {
    ...mapGetters({
      baseInfo: 'baseInfo',
      isSHowSmartGuide:'isSHowSmartGuide',
      functionData: 'functionData',
      dealerInfo: 'dealer/dealerInfo',
      hasIm: 'hasIm', // 松鼠资源位用
      callStatus: 'callStatus/callStatus',
      getpriceListResult: 'priceList/getpriceListResult',
      getSpecInfo: 'priceList/getSpecInfo',
    }),
    ...mapGetters('dealer', { dealerSeriesList: 'seriesList' }),
    dealerId() {
      return this.baseInfo.dealerId;
    },
    seriesId() {
      if (isICSApp) {
        return;
      }
      const seriesId = this.$queryParams.seriesId || 0;
      let temptSeriesId = 0;
      try {
        if (seriesId === 0 && this.dealerSeriesList.length > 0) {
          this.dealerSeriesList.forEach((element) => {
            element.SpecList.forEach((item) => {
              if (item.MaxPrice > 0) {
                temptSeriesId = element.SeriesId;
                throw new Error('End Loop');
              }
            });
          });
        } else {
          temptSeriesId = seriesId;
        }
      } catch (e) {
        console.log(e.message);
      }
      return temptSeriesId;
    },
    isIcsCallingShow() {
      return this.realtimeanswer === 1;
    },
    // 控制报价单入口显示隐藏
    showDlrQuotation() {
      // 入口显示新添加判断随机车型是否存在
      return (
        this.dealerSeriesList.length && this.callStatus === 2 && this.delay
      );
    },
    showDlrQuotationLoad() {
      return this.callStatus === 1 && this.getpriceListResult.fullLandingPrice;
    },
  },
  created: staticIdProxy(function () {
    if (!this.supportWebGL) {
      return;
    }
    this.logger = new Logger('Hall');
    const dealerId = this.dealerId || this.$route.params.dealerId;
    const source = this.baseInfo.source || this.$route.params.source;
    if (dealerId && source) {
      this.setBaseInfo({
        dealerId: dealerId,
        source: source,
      });
    }
    const busi = this.$route.query.busi;
    if (this.realtimeanswer === 1 || busi === 'ics') {
      // 隐藏
      this.$store.commit('busiIcsApp/SET_ICS_STATUS', { icsShowState: 0 });
    }
    if (this.realtimeanswer === 1) {
      const saledSeriesId = this.$queryParams.seriesId || 0;
      this.getAractivityState({
        seriesId: saledSeriesId,
        dealerId: this.dealerId,
      });
    }
    this.getSpecListByDealerId(dealerId);
    this.getBaseInfo().then(() => {
      this.baseInfoLoaded = true;
      document.title = '汽车之家-智能展厅-' + this.baseInfo.dealerName;
      if (this.baseInfo && this.baseInfo.fdRight && this.baseInfo.fdRight && this.baseInfo.fdRight.sceneId) {
        this.sceneId = this.baseInfo.fdRight.sceneId
      }
      const fdRight = this.baseInfo.fdRight;
      if (fdRight.hasRights && fdRight.hasPublish && fdRight.sceneId) {
        this.getHasSmartGuide()
      }
      this.getFunctionData();
      
    });
  }, 'hall'),
  mounted () {
    if (!this.supportWebGL) {
      return;
    }
    this.getBaseInfo().then(() => {
      pvTrack.start({
        dealerId: this.baseInfo.dealerId,
        dealerInfoId: this.baseInfo.dealerInfoId,
        source: this.baseInfo.source,
        cityId: this.baseInfo.cityId,
      });
      this.getFunctionData().then(() => {
        this.functionDataLoaded = true;
        homePoup.open(this.$queryParams, this.$store.state, {
          isInWorkTime: isInWorkTime,
          hasIm: this.hasIm,
        });
        this.initShare();
        hideLoading();
      });
      initResizeEvent();
    });
    // 中转两端同步之后，用户意向的事件传递
    this.$bus.$on('queryPicList', () => {
      this.queryPicList();
    });
    this.$bus.$on('openSmartGuide', () => {
      this.startSmartGide();
      this.setIsSHowSmartGuide(true);
    });
    this.$bus.$on('cancelSmartGuide', () => {
      this.cancelSmartGide();
      this.taskExecutor.stop()
      this.setIsSHowSmartGuide(false);
    });
    eventBus.$on('toggleGuide', (state) => {
      if(!this.isSHowSmartGuide) return
      if (state === 'pause') {
        preMuted = this.taskExecutor.getMuted()
        this.muted = this.taskExecutor.toggleMute(true)
        smartGide.changePause(true)
      } else {
        if (!preMuted) {
          this.muted = this.taskExecutor.toggleMute(false)
        }
        smartGide.changePause(false)
      }
    });
    eventBus.$on('getMuted', () => {
      if(!this.isSHowSmartGuide) return
      this.muted = this.taskExecutor.toggleMute()     
      smartGide.changePause(false)
    });
    eventBus.$on('directiveLeaveGuide', () => {
      this.$refs['bottomNewRef'].offGuide()
    })
  },
  methods: {
    ...mapMutations({
      setBaseInfo: 'setBaseInfo',
      setIsSHowSmartGuide: 'setIsSHowSmartGuide',
      setSalesSeriesId: 'dealer/setSalesSeriesId',
    }),
    ...mapActions({
      getBaseInfo: 'getBaseInfo',
      getFunctionData: 'getFunctionData',
      getSpecListByDealerId: 'dealer/getSpecListByDealerId',
      getAractivityState: 'redPacket/getAractivityState',
    }),
    // C端接收到用户意向已经保存成功，向B端发送信号
    queryPicList: actionProxy('sendPicListPromise', function () {
      console.log('端接收到用户意向已经保存成功，向B端发送信号');
    }),
    // B端接收到信号之后，开始执行自己的获取C端用户已选的意向数据等相关方法。从这里开始！
    sendPicListPromise() {
      this.$bus.$emit('sendPicListPromise');
    },
    startSmartGide () {
      smartGide = new SmartGuide(this.panoPromise, this.dealerId,this.sceneId);
      this.getAudioInfo();
    },
    getHasSmartGuide () {
      smartApi.getGuideSetting(this.dealerId,this.sceneId).then((res) => { 
        if (res && res.pointLine && res.pointLine.length) {
          this.hasSmartGuide = true
        } else {
          this.hasSmartGuide = false
        }
      })
    },
    getAudioInfo() {
      smartApi.getAudioInfo(this.dealerId).then((res) => {
        if (res.length) {
          this.taskExecutor = new CarTaskExecutor(res);
          this.taskExecutor.execute(res[0]);
          this.audioContent = res[0]
          this.muted = this.taskExecutor.toggleMute(false)
          this.taskExecutor.on('audioContent', (content) => {
            this.audioContent = content;
          });
        }
      });
    },
    cancelSmartGide() {
      smartGide.cancelGuide();
    },
    initShare() {
      shareManager.init({
        baseInfo: this.baseInfo,
        shareInfo: this.functionData.shareInfo,
      });
      shareManager.on(ShareManager.EVENTS.SHARED_SUCCESS, () => {
        sharedRedbag.showSharedRedPacket(this.dealerId);
      });
      this.setShareData();
    },
    setShareData() {
      var from = this.$queryParams.from;
      if (this.realtimeanswer !== 1) {
        if (from !== queryValue.QUERY_FROM_BDXIAOCHENGXU) {
          this.setAdvisorShare();
        } else {
          shareManager.setDefaultShare();
        }
      }
    },
    setAdvisorShare() {
      const imInfo = this.functionData.imInfo;
      if (this.hasIm) {
        // 顾问存在显示卡片
        if (imInfo.shareAdvisor) {
          imInfo.shareAdvisor.dealerName = this.baseInfo.dealerName;
          shareManager.setAdviserShare(imInfo.shareAdvisor);
        } else {
          shareManager.setDefaultShare();
        }
      } else {
        shareManager.setDefaultShare();
      }
    },
    initPriceListFunc() {
      const dealerId = this.dealerId || this.$route.params.dealerId;
      this.getBaseInfo()
        .then(() => {
          return this.getSpecListByDealerId(dealerId);
        })
        .then((data) => {
          if (data.length) {
            data.forEach((element) => {
              element.SpecList.forEach((item) => {
                if (item.MaxPrice > 0) {
                  const args = {
                    SpecId: item.SpecId,
                    SpecName: item.SpecName,
                    ImageUrl: element.SeriesTransparentImg,
                    MinPrice: item.MinPrice,
                    NewsPrice: item.NewsPrice,
                  };
                  this.$store.commit('priceList/setSpecInfo', args);
                  const { selectOneCar, getActivitiesFn } =
                    userSeriesCarLayer();
                  selectOneCar(args);
                  getActivitiesFn(this.dealerId);
                  this.setSalesSeriesId(element.SeriesId);
                  if (isICSApp) {
                    this.changeDeLay();
                  }
                  throw new Error('End Loop');
                }
              });
            });
          }
        });
    },
    changeDeLay() {
      const _this = this;
      setTimeout(function () {
        _this.delay = true;
      }, 3000);
    },
  },
  watch: {
    seriesId: {
      handler: function (newVal) {
        if (newVal > 0) {
          this.setSalesSeriesId(newVal);
        }
      },
      immediate: true,
    },
    callStatus: {
      handler: function (newVal) {
        // 通话中去请求相应接口
        if (isICSApp) {
          if (newVal === 2 && this.dealerId > 0) {
            this.initPriceListFunc();
          } else {
            this.$store.commit('setHasWXshow', false); // 打开报价单留资
            this.delay = false;
          }
        } else {
          if (newVal === 1 && this.dealerId > 0) {
            // 用户端呼叫中去请求接口
            this.initPriceListFunc();
          } else if (newVal === 0) {
            this.$store.commit('setHasWXshow', false); // 打开报价单留资
            this.delay = false;
          } else {
            this.changeDeLay();
          }
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.$bus.$off('openSmartGuide');
    this.$bus.$off('cancelSmartGuide');
    eventBus.$off('toggleGuide')
    eventBus.$off('getMuted')
    eventBus.$off('directiveLeaveGuide')
  },
};
</script>
<style scoped>
#container {
  width: 100%;
  height: 100%;
}
</style>

<style lang="scss">
html {
  font-size: calc(40 * 100vw / 750);
}

@media screen and (min-width: 750px) {
  html {
    font-size: 40px;
  }
}
</style>
